import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = { class: "flex flex-grow items-center xl:justify-end" }
const _hoisted_10 = { class: "md:hidden mr-1" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "flex justify-end" }
const _hoisted_13 = { class: "hidden md:block ml-3" }
const _hoisted_14 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 192px)"}
}
const _hoisted_15 = { class: "custom-title flex flex-col" }
const _hoisted_16 = { class: "ml-auto" }
const _hoisted_17 = { style: {"overflow-y":"auto","height":"calc(100vh - 242px)"} }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-4xl" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "text-3xl" }
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_27 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_28 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_29 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_30 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_31 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_32 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_33 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_34 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_35 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_36 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_37 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_38 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_39 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_40 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_41 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_42 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_43 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_44 = ["onClick"]
const _hoisted_45 = {
  key: 1,
  class: "flex flex-wrap gap-4 p-4"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "flex flex-col justify-between" }
const _hoisted_48 = { class: "text-5xl" }
const _hoisted_49 = { class: "flex justify-center" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  class: "h-[120px]",
  align: "center"
}
const _hoisted_53 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_54 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_55 = { class: "flex justify-between" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["onClick"]
const _hoisted_59 = { class: "flex justify-between items-center" }
const _hoisted_60 = { class: "w-1/2" }
const _hoisted_61 = { class: "flex flex-col" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_64 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_65 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_66 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_67 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_68 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_69 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_70 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_71 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_72 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_73 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_74 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_75 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_76 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_77 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_78 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_79 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_80 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_81 = { class: "flex flex-grow ml-2" }
const _hoisted_82 = ["onClick"]
const _hoisted_83 = { class: "text-3xl" }
const _hoisted_84 = {
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_85 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "text-5xl" }
const _hoisted_88 = { class: "flex" }
const _hoisted_89 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_90 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_91 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_92 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_93 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_94 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_95 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_96 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_97 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_98 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_99 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_100 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_101 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_102 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_103 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_104 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_105 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_106 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_107 = ["onClick"]
const _hoisted_108 = {
  key: 1,
  class: "flex flex-wrap gap-4 p-4"
}
const _hoisted_109 = { class: "flex justify-between" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = ["onClick"]
const _hoisted_113 = { class: "flex flex-col justify-between" }
const _hoisted_114 = { class: "flex justify-between items-center" }
const _hoisted_115 = { class: "w-1/2" }
const _hoisted_116 = { class: "flex flex-col" }
const _hoisted_117 = { class: "flex" }
const _hoisted_118 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_119 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_120 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_121 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_122 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_123 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_124 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_125 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_126 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_127 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_128 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_129 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_130 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_131 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_132 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_133 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_134 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_135 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_136 = { class: "flex flex-grow ml-2" }
const _hoisted_137 = ["onClick"]
const _hoisted_138 = { class: "text-3xl" }
const _hoisted_139 = {
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_140 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_141 = { class: "hidden md:block w-full" }
const _hoisted_142 = { class: "mx-12" }
const _hoisted_143 = { class: "flex" }
const _hoisted_144 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_145 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_146 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_147 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_148 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_149 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_150 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_151 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_152 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_153 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_154 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_155 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_156 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_157 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_158 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_159 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_160 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_161 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_162 = ["onClick"]
const _hoisted_163 = ["onClick"]
const _hoisted_164 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_165 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_166 = { class: "flex" }
const _hoisted_167 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_168 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_169 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_170 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_171 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_172 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_173 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_174 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_175 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_176 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_177 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_178 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_179 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_180 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_181 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_182 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_183 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_184 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_185 = ["onClick"]
const _hoisted_186 = ["onClick"]
const _hoisted_187 = {
  key: 1,
  style: {"height":"calc(100vh - 260px)"}
}
const _hoisted_188 = { style: {"height":"calc(100vh - 270px)","overflow-y":"auto"} }
const _hoisted_189 = { class: "flex flex-wrap gap-4 p-4" }
const _hoisted_190 = { key: 0 }
const _hoisted_191 = { class: "h-[100px] flex flex-col justify-between" }
const _hoisted_192 = { class: "text-4xl" }
const _hoisted_193 = { class: "flex justify-center" }
const _hoisted_194 = ["onClick"]
const _hoisted_195 = ["onClick"]
const _hoisted_196 = {
  class: "h-[100px]",
  align: "center"
}
const _hoisted_197 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_198 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_199 = { class: "flex justify-between" }
const _hoisted_200 = ["onClick"]
const _hoisted_201 = ["onClick"]
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { class: "flex justify-between items-center" }
const _hoisted_204 = { class: "flex flex-col" }
const _hoisted_205 = { class: "flex" }
const _hoisted_206 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_207 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_208 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_209 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_210 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_211 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_212 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_213 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_214 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_215 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_216 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_217 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_218 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_219 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_220 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_221 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_222 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_223 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_224 = { class: "flex flex-grow ml-2" }
const _hoisted_225 = ["onClick"]
const _hoisted_226 = { class: "text-3xl" }
const _hoisted_227 = {
  key: 1,
  class: "w-full quantity-editor"
}
const _hoisted_228 = {
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_229 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_230 = { class: "flex justify-between" }
const _hoisted_231 = ["onClick"]
const _hoisted_232 = ["onClick"]
const _hoisted_233 = ["onClick"]
const _hoisted_234 = { class: "h-[100px] flex flex-col justify-between" }
const _hoisted_235 = { class: "flex justify-between items-center" }
const _hoisted_236 = { class: "flex flex-col" }
const _hoisted_237 = { class: "flex" }
const _hoisted_238 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_239 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_240 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_241 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_242 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_243 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_244 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_245 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_246 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_247 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_248 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_249 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_250 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_251 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_252 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_253 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_254 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_255 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_256 = { class: "flex flex-grow ml-2" }
const _hoisted_257 = ["onClick"]
const _hoisted_258 = { class: "text-3xl" }
const _hoisted_259 = {
  key: 1,
  class: "w-full quantity-editor"
}
const _hoisted_260 = {
  class: "h-[160px] mt-2",
  align: "center"
}
const _hoisted_261 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_262 = { class: "flex w-full justify-end mt-4" }
const _hoisted_263 = { class: "hidden md:block mr-3" }
const _hoisted_264 = { class: "md:hidden" }
const _hoisted_265 = { class: "flex-col w-full px-2 justify-center items-center" }
const _hoisted_266 = {
  key: 0,
  class: "w-full md:px-2"
}
const _hoisted_267 = { class: "flex flex-col md:flex-row" }
const _hoisted_268 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_269 = { class: "w-full md:w-1/2 md:px-2" }
const _hoisted_270 = { class: "flex w-full items-center justify-center" }
const _hoisted_271 = { class: "w-full" }
const _hoisted_272 = ["src"]
const _hoisted_273 = { class: "el-upload-list__item-actions" }
const _hoisted_274 = ["onClick"]
const _hoisted_275 = ["onClick"]
const _hoisted_276 = { class: "flex flex-col w-full" }
const _hoisted_277 = {
  key: 0,
  class: "barcode-scanner-container"
}
const _hoisted_278 = { class: "dialog-footer flex items-center" }
const _hoisted_279 = { class: "flex gap-2 ml-auto" }
const _hoisted_280 = { class: "flex justify-center items-center" }
const _hoisted_281 = ["src"]
const _hoisted_282 = { class: "dialog-footer flex items-center" }
const _hoisted_283 = { class: "flex gap-2 ml-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!
  const _component_ImgLoading = _resolveComponent("ImgLoading")!
  const _component_CarouselLoading = _resolveComponent("CarouselLoading")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_zoom_in = _resolveComponent("zoom-in")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_BarcodeScanner = _resolveComponent("BarcodeScanner")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_QuantityEditDrawer = _resolveComponent("QuantityEditDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-5' : (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead ? 'md:grid-cols-4' : 'md:grid-cols-3'),
                            ]])
                    }, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "部門"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.department_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "カテゴリ"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CategorySelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            modelValue: _ctx.searchForm.category_id,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                            "is-search": true,
                            placeholder: "カテゴリを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "アイテム名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AutoCompleteInput, {
                            modelValue: _ctx.searchForm.material_name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                            placeholder: "アイテム名を入力",
                            "storage-key": "material-name-history",
                            "max-history-items": 15,
                            ref: "materialNameInput"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "組織"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "部門"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.department_id,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                                placeholder: "部門を選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                          ]),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "カテゴリ"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CategorySelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                modelValue: _ctx.searchForm.category_id,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                                "is-search": true,
                                placeholder: "カテゴリを選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "アイテム名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteInput, {
                                  modelValue: _ctx.searchForm.material_name,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.material_name) = $event)),
                                  placeholder: "アイテム名を入力",
                                  "storage-key": "material-name-history",
                                  "max-history-items": 15,
                                  ref: "materialNameInput"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[46] || (_cache[46] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    (!_ctx.isGrid)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.updateGridMode(true))),
                          circle: ""
                        }, {
                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                            _createElementVNode("span", { class: "material-symbols-outlined" }, " lists ", -1)
                          ])),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateGridMode(false))),
                          circle: ""
                        }, {
                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                            _createElementVNode("span", { class: "material-symbols-outlined" }, " grid_view ", -1)
                          ])),
                          _: 1
                        }))
                  ]),
                  _cache[49] || (_cache[49] = _createElementVNode("div", { class: "md:hidden xl:block" }, [
                    _createElementVNode("div", { class: "flex justify-end" }, [
                      _createElementVNode("span", { class: "text-xs md:text-sm m-2 font-bold" }, "アラート区分"),
                      _createElementVNode("div", { class: "flex flex-wrap gap-x-2" }, [
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#E63415] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "1日以内")
                        ]),
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#FF6600] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "1日前")
                        ]),
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#FFDE0A] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "7日前")
                        ]),
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#1EC79D] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "15日前")
                        ]),
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#14CCCC] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "30日前")
                        ]),
                        _createElementVNode("div", { class: "flex items-center" }, [
                          _createElementVNode("div", { class: "h-3 w-3 bg-[#4167F0] rounded-sm" }),
                          _createElementVNode("span", { class: "ml-1 text-xs md:text-sm" }, "在庫数")
                        ])
                      ])
                    ])
                  ], -1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_button, {
                      class: "custom-icon-btn md:hidden",
                      type: "info",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.drawer = true)),
                      circle: ""
                    }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      class: "custom-icon-btn md:hidden",
                      type: "info",
                      onClick: _ctx.handleAddButton,
                      circle: ""
                    }, {
                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      class: "hidden md:block w-24",
                      type: "info",
                      onClick: _ctx.handleAddButton
                    }, {
                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                        _createTextVNode("新規登録")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_upload, {
                      class: "",
                      ref: "upload",
                      "on-change": _ctx.handleImportButton,
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".csv"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "CSVインポート",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "custom-icon-btn mx-3",
                              type: "info",
                              circle: ""
                            }, {
                              default: _withCtx(() => _cache[53] || (_cache[53] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, " upload_2 ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-change"]),
                    _createVNode(_component_el_button, {
                      class: "custom-icon-btn",
                      type: "info",
                      onClick: _ctx.handleExportButton,
                      circle: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "CSVエクスポート",
                          placement: "top"
                        }, {
                          default: _withCtx(() => _cache[54] || (_cache[54] = [
                            _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createElementVNode("div", _hoisted_13, [
                      (!_ctx.isGrid)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            class: "w-12",
                            style: {"background-color":"#ffffff"},
                            text: "",
                            bg: "",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateGridMode(true)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => _cache[55] || (_cache[55] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined mt-1" }, "lists", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            class: "w-12 hidden md:block",
                            style: {"background-color":"#ffffff"},
                            text: "",
                            bg: "",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateGridMode(false)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => _cache[56] || (_cache[56] = [
                                  _createElementVNode("span", { class: "material-symbols-outlined mt-1" }, "grid_view", -1)
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                    ])
                  ]),
                  _cache[57] || (_cache[57] = _createElementVNode("div", { class: "flex justify-end hidden md:block xl:hidden" }, [
                    _createElementVNode("span", { class: "text-sm mr-2 font-bold" }, "アラート区分"),
                    _createElementVNode("div", { class: "flex flex-wrap gap-x-2" }, [
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#E63415] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "1日以内")
                      ]),
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#FF6600] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "1日前")
                      ]),
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#FFDE0A] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "7日前")
                      ]),
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#1EC79D] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "15日前")
                      ]),
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#14CCCC] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "30日前")
                      ]),
                      _createElementVNode("div", { class: "flex items-center" }, [
                        _createElementVNode("div", { class: "h-3 w-3 bg-[#4167F0] rounded-sm" }),
                        _createElementVNode("span", { class: "ml-1 text-sm" }, "在庫数")
                      ])
                    ])
                  ], -1))
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[58] || (_cache[58] = _createElementVNode("span", null, "在庫一覧（在庫数　品名　有効期間）", -1)),
                _createElementVNode("span", _hoisted_16, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                ((_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)) && !_ctx.searchDepartmentId)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!_ctx.isGrid)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mTableData, (item) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                              key: item.inventory_id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 1 }, {
                                      default: _withCtx(() => [
                                        (!item.isExpand)
                                          ? (_openBlock(), _createElementBlock("span", {
                                              key: 0,
                                              class: "material-symbols-outlined cursor-pointer",
                                              onClick: ($event: any) => (_ctx.handleExpandButton(item))
                                            }, [
                                              _createVNode(_component_el_icon, { size: 20 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ArrowRight)
                                                ]),
                                                _: 1
                                              })
                                            ], 8, _hoisted_18))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              class: "material-symbols-outlined cursor-pointer",
                                              onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                                            }, [
                                              _createVNode(_component_el_icon, { size: 20 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ArrowDown)
                                                ]),
                                                _: 1
                                              })
                                            ], 8, _hoisted_19))
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, {
                                      span: 7,
                                      class: "ml-2",
                                      align: "middle"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_20, _toDisplayString(item.quantity), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, {
                                      span: 14,
                                      class: "ml-2"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.organization_name), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                        _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024),
                                (item.isExpand)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-lg font-bold mb-2" }, "詳細", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details, (detail) => {
                                        return (_openBlock(), _createBlock(_component_el_card, {
                                          style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                                          key: detail.inventory_id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_row, { align: "middle" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_col, {
                                                  span: 8,
                                                  align: "middle"
                                                }, {
                                                  default: _withCtx(() => [
                                                    (!detail.quantity_is_click)
                                                      ? (_openBlock(), _createElementBlock("div", {
                                                          key: 0,
                                                          class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                                          onClick: ($event: any) => (_ctx.handleClickQuantityButton(detail))
                                                        }, [
                                                          _createElementVNode("span", _hoisted_24, _toDisplayString(detail.quantity), 1)
                                                        ], 8, _hoisted_23))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_el_col, {
                                                  span: 12,
                                                  class: "ml-2",
                                                  onClick: ($event: any) => (_ctx.handleEditButton(detail, true))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", null, _toDisplayString(detail.department_name), 1),
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["text-xl font-bold", { 'text-red-500': new Date(detail.expiration_date) < new Date() }])
                                                    }, _toDisplayString(_ctx.moment(detail.expiration_date).format('YYYY-MM-DD')), 3),
                                                    _createElementVNode("div", _hoisted_25, [
                                                      (detail.check_result1 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                                                        : (detail.check_result1 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_27))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_28)),
                                                      (detail.check_result2 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                                                        : (detail.check_result2 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_31)),
                                                      (detail.check_result3 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32))
                                                        : (detail.check_result3 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_33))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_34)),
                                                      (detail.check_result4 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                                                        : (detail.check_result4 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_37)),
                                                      (detail.check_result5 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38))
                                                        : (detail.check_result5 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_40)),
                                                      (detail.check_result6 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_41))
                                                        : (detail.check_result6 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_43))
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_el_col, {
                                                  span: 2,
                                                  class: "ml-2",
                                                  align: "right"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("span", {
                                                      class: "material-symbols-outlined cursor-pointer",
                                                      onClick: ($event: any) => (_ctx.handleAlarmButton(detail))
                                                    }, " alarm ", 8, _hoisted_44)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_card, {
                                style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                                key: item.inventory_id
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(item.organization_name), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_47, [
                                    _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                    _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                                  ]),
                                  _createVNode(_component_el_row, { align: "middle" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, {
                                        span: 10,
                                        justify: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[60] || (_cache[60] = _createElementVNode("div", null, "在庫合計", -1)),
                                          _createElementVNode("div", _hoisted_48, _toDisplayString(item.quantity), 1),
                                          _createElementVNode("div", _hoisted_49, [
                                            (!item.isExpand)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: "material-symbols-outlined cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.handleExpandButton(item))
                                                }, [
                                                  _createVNode(_component_el_icon, { size: 16 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ArrowDown)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_50))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "material-symbols-outlined cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                                                }, [
                                                  _createVNode(_component_el_icon, { size: 16 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ArrowUp)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_51))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_col, { span: 14 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_52, [
                                            (item.images)
                                              ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                                  key: 0,
                                                  modelValue: item.images,
                                                  "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                                  class: "carousel-image"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_53))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.isExpand)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        _cache[62] || (_cache[62] = _createElementVNode("span", { class: "text-lg font-bold" }, "詳細", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details, (detail) => {
                                          return (_openBlock(), _createBlock(_component_el_card, {
                                            class: "mt-2",
                                            style: {"width":"100%","border":"1px solid #d1d5db","border-radius":"10px"},
                                            key: detail.inventory_id
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_55, [
                                                _createElementVNode("div", null, _toDisplayString(detail.department_name), 1),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer",
                                                    onClick: ($event: any) => (_ctx.handleEditButton(detail))
                                                  }, " edit_square ", 8, _hoisted_56),
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer ml-2",
                                                    onClick: ($event: any) => (_ctx.handleAlarmButton(detail))
                                                  }, " alarm ", 8, _hoisted_57),
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer ml-2",
                                                    onClick: ($event: any) => (_ctx.handleDeleteButton(detail))
                                                  }, " delete ", 8, _hoisted_58)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_59, [
                                                _createElementVNode("div", _hoisted_60, [
                                                  _createElementVNode("div", _hoisted_61, [
                                                    _createElementVNode("div", null, [
                                                      _cache[61] || (_cache[61] = _createElementVNode("span", null, "期限", -1)),
                                                      _createElementVNode("span", {
                                                        class: _normalizeClass(["ml-2", { 'text-red-500': new Date(detail.expiration_date) < new Date() }])
                                                      }, _toDisplayString(_ctx.moment(detail.expiration_date).format('YYYY-MM-DD')), 3)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_62, [
                                                      (detail.check_result1 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_63))
                                                        : (detail.check_result1 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_65)),
                                                      (detail.check_result2 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_66))
                                                        : (detail.check_result2 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_67))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_68)),
                                                      (detail.check_result3 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_69))
                                                        : (detail.check_result3 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_70))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_71)),
                                                      (detail.check_result4 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_72))
                                                        : (detail.check_result4 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_73))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_74)),
                                                      (detail.check_result5 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_75))
                                                        : (detail.check_result5 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_76))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_77)),
                                                      (detail.check_result6 === 1)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_78))
                                                        : (detail.check_result6 === 2)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_79))
                                                          : (_openBlock(), _createElementBlock("div", _hoisted_80))
                                                    ])
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_81, [
                                                  (!detail.quantity_is_click)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                                        onClick: ($event: any) => (_ctx.handleClickQuantityButton(detail))
                                                      }, [
                                                        _createElementVNode("span", _hoisted_83, _toDisplayString(detail.quantity), 1)
                                                      ], 8, _hoisted_82))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_84, [
                                                (detail.images)
                                                  ? (_openBlock(), _createBlock(_component_CarouselLoading, {
                                                      key: 0,
                                                      modelValue: detail.images,
                                                      "onUpdate:modelValue": ($event: any) => ((detail.images) = $event),
                                                      height: "160px"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_85))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.isGrid)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mTableData, (item) => {
                            return (_openBlock(), _createBlock(_component_el_card, {
                              style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                              key: item.inventory_id
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, {
                                      span: 8,
                                      align: "middle"
                                    }, {
                                      default: _withCtx(() => [
                                        (!item.quantity_is_click)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                              onClick: ($event: any) => (_ctx.handleClickQuantityButton(item))
                                            }, [
                                              _createElementVNode("span", _hoisted_87, _toDisplayString(item.quantity), 1)
                                            ], 8, _hoisted_86))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_col, {
                                      span: 12,
                                      class: "ml-2",
                                      onClick: ($event: any) => (_ctx.handleEditButton(item, true))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["text-xl font-bold", { 'text-red-500': new Date(item.expiration_date) < new Date() }])
                                        }, _toDisplayString(_ctx.moment(item.expiration_date).format('YYYY-MM-DD')), 3),
                                        _createElementVNode("div", _hoisted_88, [
                                          (item.check_result1 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_89))
                                            : (item.check_result1 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_90))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_91)),
                                          (item.check_result2 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_92))
                                            : (item.check_result2 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_93))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_94)),
                                          (item.check_result3 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_95))
                                            : (item.check_result3 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_96))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_97)),
                                          (item.check_result4 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_98))
                                            : (item.check_result4 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_99))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_100)),
                                          (item.check_result5 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_101))
                                            : (item.check_result5 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_102))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_103)),
                                          (item.check_result6 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104))
                                            : (item.check_result6 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_105))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_106))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_el_col, {
                                      span: 2,
                                      class: "ml-2",
                                      align: "right"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", {
                                          class: "material-symbols-outlined cursor-pointer",
                                          onClick: ($event: any) => (_ctx.handleAlarmButton(item))
                                        }, " alarm ", 8, _hoisted_107)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_card, {
                                style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px"},
                                key: item.inventory_id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_109, [
                                    _createElementVNode("div", null, _toDisplayString(item.department_name), 1),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer",
                                        onClick: ($event: any) => (_ctx.handleEditButton(item))
                                      }, " edit_square ", 8, _hoisted_110),
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer ml-2",
                                        onClick: ($event: any) => (_ctx.handleAlarmButton(item))
                                      }, " alarm ", 8, _hoisted_111),
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer ml-2",
                                        onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                      }, " delete ", 8, _hoisted_112)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_113, [
                                    _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                    _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _createElementVNode("div", _hoisted_115, [
                                      _createElementVNode("div", _hoisted_116, [
                                        _createElementVNode("div", null, [
                                          _cache[63] || (_cache[63] = _createElementVNode("span", null, "期限", -1)),
                                          _createElementVNode("span", {
                                            class: _normalizeClass(["ml-2", { 'text-red-500': new Date(item.expiration_date) < new Date() }])
                                          }, _toDisplayString(_ctx.moment(item.expiration_date).format('YYYY-MM-DD')), 3)
                                        ]),
                                        _createElementVNode("div", _hoisted_117, [
                                          (item.check_result1 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_118))
                                            : (item.check_result1 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_119))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_120)),
                                          (item.check_result2 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_121))
                                            : (item.check_result2 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_122))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_123)),
                                          (item.check_result3 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_124))
                                            : (item.check_result3 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_125))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_126)),
                                          (item.check_result4 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_127))
                                            : (item.check_result4 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_128))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_129)),
                                          (item.check_result5 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_130))
                                            : (item.check_result5 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_131))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_132)),
                                          (item.check_result6 === 1)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_133))
                                            : (item.check_result6 === 2)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_134))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_135))
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_136, [
                                      (!item.quantity_is_click)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                            onClick: ($event: any) => (_ctx.handleClickQuantityButton(item))
                                          }, [
                                            _createElementVNode("span", _hoisted_138, _toDisplayString(item.quantity), 1)
                                          ], 8, _hoisted_137))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_139, [
                                    (item.images)
                                      ? (_openBlock(), _createBlock(_component_CarouselLoading, {
                                          key: 0,
                                          modelValue: item.images,
                                          "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                          height: "160px"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_140))
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]))
                    ], 64))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_141, [
              (!_ctx.isGrid)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    data: _ctx.mTableData,
                    height: "calc(100vh - 260px)"
                  }, {
                    default: _withCtx(() => [
                      ((_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)) && !_ctx.searchDepartmentId)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_el_table_column, {
                              type: "expand",
                              label: "在庫一覧",
                              width: "80",
                              align: "center",
                              "row-key": "id"
                            }, {
                              default: _withCtx((props) => [
                                _createElementVNode("div", _hoisted_142, [
                                  _createVNode(_component_el_table, {
                                    data: props.row.details,
                                    "header-cell-style": { backgroundColor: '#ffffff', color: '#000000' }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "詳細",
                                        width: "80",
                                        align: "center"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_button, {
                                            class: "w-12",
                                            type: "info",
                                            style: {"background-color":"#b7b7b7"},
                                            text: "",
                                            bg: "",
                                            onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                                          }, {
                                            default: _withCtx(() => _cache[64] || (_cache[64] = [
                                              _createElementVNode("span", null, "詳細", -1)
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "department_name",
                                        label: "所属部門",
                                        width: "160"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "storage_date",
                                        label: "保管日",
                                        width: "100",
                                        align: "center"
                                      }, {
                                        default: _withCtx(({ row }) => [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.storage_date).format('YYYY-MM-DD')), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "expiration_date",
                                        label: "有効期限",
                                        width: "100",
                                        align: "center"
                                      }, {
                                        default: _withCtx(({ row }) => [
                                          _createElementVNode("span", {
                                            class: _normalizeClass({ 'text-red-500 bg-gray-200': new Date(row.expiration_date) < new Date() })
                                          }, _toDisplayString(_ctx.moment(row.expiration_date).format('YYYY-MM-DD')), 3)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "quantity",
                                        label: "在庫数",
                                        width: "66",
                                        "header-align": "center",
                                        align: "right"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "",
                                        label: "画像",
                                        width: "130"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_row, { align: "middle" }, {
                                            default: _withCtx(() => [
                                              (scope.row.images)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getImgUrls(scope.row.images), (image) => {
                                                    return (_openBlock(), _createBlock(_component_ImgLoading, {
                                                      key: image,
                                                      "model-value": image,
                                                      class: "thumbnail mr-1"
                                                    }, null, 8, ["model-value"]))
                                                  }), 128))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        prop: "check_result",
                                        label: "アラート状況",
                                        width: "110",
                                        align: "center"
                                      }, {
                                        default: _withCtx(({ row }) => [
                                          _createElementVNode("div", _hoisted_143, [
                                            (row.check_result1 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_144))
                                              : (row.check_result1 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_145))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_146)),
                                            (row.check_result2 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_147))
                                              : (row.check_result2 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_148))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_149)),
                                            (row.check_result3 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_150))
                                              : (row.check_result3 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_151))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_152)),
                                            (row.check_result4 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_153))
                                              : (row.check_result4 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_154))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_155)),
                                            (row.check_result5 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_156))
                                              : (row.check_result5 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_157))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_158)),
                                            (row.check_result6 === 1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_159))
                                              : (row.check_result6 === 2)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_160))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_161))
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "アラート",
                                        width: "80",
                                        align: "center"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "material-symbols-outlined cursor-pointer mt-2",
                                            onClick: ($event: any) => (_ctx.handleAlarmButton(scope.row))
                                          }, " alarm ", 8, _hoisted_162)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "削除",
                                        width: "52",
                                        align: "center"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "material-symbols-outlined cursor-pointer mt-2",
                                            onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                                          }, " delete ", 8, _hoisted_163)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["data"])
                                ])
                              ]),
                              _: 1
                            }),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  prop: "organization_name",
                                  label: "所属組織",
                                  width: "200"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_table_column, {
                              prop: "category_name",
                              label: "カテゴリ",
                              width: "160"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "material_name",
                              label: "アイテム名",
                              "min-width": "400"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                                _cache[65] || (_cache[65] = _createElementVNode("br", null, null, -1)),
                                (scope.row.jancode)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_164, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "quantity",
                              label: "在庫数",
                              width: "66",
                              "header-align": "center",
                              align: "right"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "",
                              label: "画像",
                              width: "52",
                              align: "center"
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_ImgLoading, {
                                  modelValue: scope.row.images,
                                  "onUpdate:modelValue": ($event: any) => ((scope.row.images) = $event),
                                  class: "thumbnail"
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            })
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_el_table_column, {
                              label: "在庫一覧",
                              width: "80",
                              align: "center"
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_el_button, {
                                  class: "w-12",
                                  type: "info",
                                  style: {"background-color":"#b7b7b7"},
                                  text: "",
                                  bg: "",
                                  onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                                }, {
                                  default: _withCtx(() => _cache[66] || (_cache[66] = [
                                    _createElementVNode("span", null, "詳細", -1)
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 1
                            }),
                            (_ctx.searchDepartmentId)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  prop: "organization_name",
                                  label: "所属組織",
                                  width: "200"
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.searchDepartmentId)
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 1,
                                  prop: "department_name",
                                  label: "所属部門",
                                  width: "160"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_el_table_column, {
                              prop: "category_name",
                              label: "カテゴリ",
                              width: "160"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "material_name",
                              label: "アイテム名",
                              "min-width": "400"
                            }, {
                              default: _withCtx((scope) => [
                                _createTextVNode(_toDisplayString(scope.row.material_name), 1),
                                _cache[67] || (_cache[67] = _createElementVNode("br", null, null, -1)),
                                (scope.row.jancode)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_165, " （" + _toDisplayString(scope.row.jancode) + "） ", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "storage_date",
                              label: "保管日",
                              width: "100",
                              align: "center"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", null, _toDisplayString(_ctx.moment(row.storage_date).format('YYYY-MM-DD')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "expiration_date",
                              label: "有効期限",
                              width: "100",
                              align: "center"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'text-red-500 bg-gray-200': new Date(row.expiration_date) < new Date() })
                                }, _toDisplayString(_ctx.moment(row.expiration_date).format('YYYY-MM-DD')), 3)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "quantity",
                              label: "在庫数",
                              width: "66",
                              "header-align": "center",
                              align: "right"
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "",
                              label: "画像",
                              width: "130"
                            }, {
                              default: _withCtx((scope) => [
                                _createVNode(_component_el_row, { align: "middle" }, {
                                  default: _withCtx(() => [
                                    (scope.row.images)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getImgUrls(scope.row.images), (image) => {
                                          return (_openBlock(), _createBlock(_component_ImgLoading, {
                                            key: image,
                                            "model-value": image,
                                            class: "thumbnail mr-1"
                                          }, null, 8, ["model-value"]))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "check_result",
                              label: "アラート状況",
                              width: "110",
                              align: "center"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createElementVNode("div", _hoisted_166, [
                                  (row.check_result1 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_167))
                                    : (row.check_result1 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_168))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_169)),
                                  (row.check_result2 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_170))
                                    : (row.check_result2 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_171))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_172)),
                                  (row.check_result3 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_173))
                                    : (row.check_result3 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_174))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_175)),
                                  (row.check_result4 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_176))
                                    : (row.check_result4 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_177))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_178)),
                                  (row.check_result5 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_179))
                                    : (row.check_result5 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_180))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_181)),
                                  (row.check_result6 === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_182))
                                    : (row.check_result6 === 2)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_183))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_184))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "アラート",
                              width: "80",
                              align: "center"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", {
                                  class: "material-symbols-outlined cursor-pointer mt-2",
                                  onClick: ($event: any) => (_ctx.handleAlarmButton(scope.row))
                                }, " alarm ", 8, _hoisted_185)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "削除",
                              width: "52",
                              align: "center"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("span", {
                                  class: "material-symbols-outlined cursor-pointer mt-2",
                                  onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                                }, " delete ", 8, _hoisted_186)
                              ]),
                              _: 1
                            })
                          ], 64))
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loading]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_187, [
                    _cache[72] || (_cache[72] = _createElementVNode("div", {
                      class: "custom-title flex items-center",
                      style: {"height":"40px"}
                    }, [
                      _createElementVNode("span", null, "在庫一覧（在庫数　品名　有効期間）"),
                      _createElementVNode("span")
                    ], -1)),
                    _createElementVNode("div", _hoisted_188, [
                      _createElementVNode("div", _hoisted_189, [
                        ((_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)) && !_ctx.searchDepartmentId)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mTableData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_card, {
                                style: {"width":"292px","border":"2px solid #d1d5db","border-radius":"10px"},
                                key: item.inventory_id
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(item.organization_name), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_191, [
                                    _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                    _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                                  ]),
                                  _createVNode(_component_el_row, { align: "middle" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_col, {
                                        span: 10,
                                        justify: "center"
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[68] || (_cache[68] = _createElementVNode("div", null, "在庫合計", -1)),
                                          _createElementVNode("div", _hoisted_192, _toDisplayString(item.quantity), 1),
                                          _createElementVNode("div", _hoisted_193, [
                                            (!item.isExpand)
                                              ? (_openBlock(), _createElementBlock("span", {
                                                  key: 0,
                                                  class: "material-symbols-outlined cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.handleExpandButton(item))
                                                }, [
                                                  _createVNode(_component_el_icon, { size: 16 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ArrowDown)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_194))
                                              : (_openBlock(), _createElementBlock("span", {
                                                  key: 1,
                                                  class: "material-symbols-outlined cursor-pointer",
                                                  onClick: ($event: any) => (_ctx.handleCollapseButton(item))
                                                }, [
                                                  _createVNode(_component_el_icon, { size: 16 }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ArrowUp)
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_195))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_el_col, { span: 14 }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_196, [
                                            (item.images)
                                              ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                                  key: 0,
                                                  modelValue: item.images,
                                                  "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                                  class: "carousel-image"
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_197))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.isExpand)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_198, [
                                        _cache[70] || (_cache[70] = _createElementVNode("span", { class: "text-lg font-bold" }, "詳細", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.details, (detail) => {
                                          return (_openBlock(), _createBlock(_component_el_card, {
                                            class: "mt-2",
                                            style: {"width":"250px","border":"1px solid #d1d5db","border-radius":"10px"},
                                            key: detail.inventory_id
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_199, [
                                                _createElementVNode("div", null, _toDisplayString(detail.department_name), 1),
                                                _createElementVNode("div", null, [
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer",
                                                    onClick: ($event: any) => (_ctx.handleEditButton(detail))
                                                  }, " edit_square ", 8, _hoisted_200),
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer ml-2",
                                                    onClick: ($event: any) => (_ctx.handleAlarmButton(detail))
                                                  }, " alarm ", 8, _hoisted_201),
                                                  _createElementVNode("span", {
                                                    class: "material-symbols-outlined cursor-pointer ml-2",
                                                    onClick: ($event: any) => (_ctx.handleDeleteButton(detail))
                                                  }, " delete ", 8, _hoisted_202)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_203, [
                                                _createElementVNode("div", _hoisted_204, [
                                                  _createElementVNode("div", null, [
                                                    _cache[69] || (_cache[69] = _createElementVNode("span", null, "期限", -1)),
                                                    _createElementVNode("span", {
                                                      class: _normalizeClass(["ml-2", { 'text-red-500': new Date(detail.expiration_date) < new Date() }])
                                                    }, _toDisplayString(_ctx.moment(detail.expiration_date).format('YYYY-MM-DD')), 3)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_205, [
                                                    (detail.check_result1 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_206))
                                                      : (detail.check_result1 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_207))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_208)),
                                                    (detail.check_result2 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_209))
                                                      : (detail.check_result2 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_210))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_211)),
                                                    (detail.check_result3 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_212))
                                                      : (detail.check_result3 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_213))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_214)),
                                                    (detail.check_result4 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_215))
                                                      : (detail.check_result4 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_216))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_217)),
                                                    (detail.check_result5 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_218))
                                                      : (detail.check_result5 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_219))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_220)),
                                                    (detail.check_result6 === 1)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_221))
                                                      : (detail.check_result6 === 2)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_222))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_223))
                                                  ])
                                                ]),
                                                _createElementVNode("div", _hoisted_224, [
                                                  (!detail.quantity_is_click)
                                                    ? (_openBlock(), _createElementBlock("div", {
                                                        key: 0,
                                                        class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                                        onClick: ($event: any) => (_ctx.handleClickQuantityButtonWebMode(detail))
                                                      }, [
                                                        _createElementVNode("span", _hoisted_226, _toDisplayString(detail.quantity), 1)
                                                      ], 8, _hoisted_225))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_227, [
                                                        _createVNode(_component_el_input_number, {
                                                          ref_for: true,
                                                          ref: (el) => _ctx.setInputRef(detail.inventory_id, el),
                                                          class: "w-full big-font-input",
                                                          size: "large",
                                                          modelValue: detail.quantity,
                                                          "onUpdate:modelValue": ($event: any) => ((detail.quantity) = $event),
                                                          min: 0,
                                                          max: 999999,
                                                          "controls-position": "right",
                                                          onBlur: ($event: any) => (_ctx.handleQuantityBlur(detail)),
                                                          onFocus: ($event: any) => (_ctx.handleQuantityFocus(detail))
                                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onFocus"])
                                                      ]))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_228, [
                                                (detail.images)
                                                  ? (_openBlock(), _createBlock(_component_CarouselLoading, {
                                                      key: 0,
                                                      modelValue: detail.images,
                                                      "onUpdate:modelValue": ($event: any) => ((detail.images) = $event),
                                                      height: "160px"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_229))
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.mTableData, (item) => {
                              return (_openBlock(), _createBlock(_component_el_card, {
                                style: {"width":"250px","border":"2px solid #d1d5db","border-radius":"10px"},
                                key: item.inventory_id
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_230, [
                                    _createElementVNode("div", null, _toDisplayString(item.department_name), 1),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer",
                                        onClick: ($event: any) => (_ctx.handleEditButton(item))
                                      }, " edit_square ", 8, _hoisted_231),
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer ml-2",
                                        onClick: ($event: any) => (_ctx.handleAlarmButton(item))
                                      }, " alarm ", 8, _hoisted_232),
                                      _createElementVNode("span", {
                                        class: "material-symbols-outlined cursor-pointer ml-2",
                                        onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                      }, " delete ", 8, _hoisted_233)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_234, [
                                    _createElementVNode("div", null, _toDisplayString(item.material_name), 1),
                                    _createElementVNode("div", null, _toDisplayString(item.category_name), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_235, [
                                    _createElementVNode("div", _hoisted_236, [
                                      _createElementVNode("div", null, [
                                        _cache[71] || (_cache[71] = _createElementVNode("span", null, "期限", -1)),
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["ml-2", { 'text-red-500': new Date(item.expiration_date) < new Date() }])
                                        }, _toDisplayString(_ctx.moment(item.expiration_date).format('YYYY-MM-DD')), 3)
                                      ]),
                                      _createElementVNode("div", _hoisted_237, [
                                        (item.check_result1 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_238))
                                          : (item.check_result1 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_239))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_240)),
                                        (item.check_result2 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_241))
                                          : (item.check_result2 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_242))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_243)),
                                        (item.check_result3 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_244))
                                          : (item.check_result3 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_245))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_246)),
                                        (item.check_result4 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_247))
                                          : (item.check_result4 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_248))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_249)),
                                        (item.check_result5 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_250))
                                          : (item.check_result5 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_251))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_252)),
                                        (item.check_result6 === 1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_253))
                                          : (item.check_result6 === 2)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_254))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_255))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_256, [
                                      (!item.quantity_is_click)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: "w-full flex items-center justify-center bg-gray-100 border-2 border-gray-900 rounded-md cursor-pointer",
                                            onClick: ($event: any) => (_ctx.handleClickQuantityButtonWebMode(item))
                                          }, [
                                            _createElementVNode("span", _hoisted_258, _toDisplayString(item.quantity), 1)
                                          ], 8, _hoisted_257))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_259, [
                                            _createVNode(_component_el_input_number, {
                                              ref_for: true,
                                              ref: (el) => _ctx.setInputRef(item.inventory_id, el),
                                              class: "w-full big-font-input",
                                              size: "large",
                                              modelValue: item.quantity,
                                              "onUpdate:modelValue": ($event: any) => ((item.quantity) = $event),
                                              min: 0,
                                              max: 999999,
                                              "controls-position": "right",
                                              onBlur: ($event: any) => (_ctx.handleQuantityBlur(item)),
                                              onFocus: ($event: any) => (_ctx.handleQuantityFocus(item))
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onFocus"])
                                          ]))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_260, [
                                    (item.images)
                                      ? (_openBlock(), _createBlock(_component_CarouselLoading, {
                                          key: 0,
                                          modelValue: item.images,
                                          "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                          height: "160px"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_261))
                                  ])
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
            ]),
            _createElementVNode("div", _hoisted_262, [
              _createElementVNode("div", _hoisted_263, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_264, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handleCurrentChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_278, [
          (_ctx.form.add_update === 'update' && _ctx.dialogFormShowDel)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.handleDeleteButton2(_ctx.form.inventory_id, _ctx.form.sk)))
              }, {
                default: _withCtx(() => _cache[75] || (_cache[75] = [
                  _createTextVNode(" 削除 ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_279, [
            _createVNode(_component_el_button, {
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.dialogFormVisible = false))
            }, {
              default: _withCtx(() => _cache[76] || (_cache[76] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_265, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            rules: _ctx.rules,
            ref: "formRef"
          }, {
            default: _withCtx(() => [
              (_ctx.form.add_update === 'add')
                ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                    _createVNode(_component_el_form_item, {
                      label: "JANコード",
                      prop: "jancode",
                      "label-width": "100px",
                      error: _ctx.errors.jancode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.form.jancode,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.jancode) = $event)),
                          autocomplete: "off",
                          placeholder: "JANコード"
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              style: {"background-color":"rgb(76, 175, 80)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-right":"1px solid #dcdfe6"},
                              onClick: _ctx.handleScanStart
                            }, {
                              default: _withCtx(() => _cache[73] || (_cache[73] = [
                                _createTextVNode(" スキャンを開始")
                              ])),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              style: {"background-color":"rgb(21, 96, 130)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-radius":"0 4px 4px 0"},
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleJancodeSearch(_ctx.form.jancode || '')))
                            }, {
                              default: _withCtx(() => _cache[74] || (_cache[74] = [
                                _createTextVNode("検索")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["error"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_267, [
                _createElementVNode("div", _hoisted_268, [
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "組織",
                        prop: "organization_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.form.organization_id,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onOrganizationNameChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.organization_name = $event)),
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "部門",
                        prop: "department_id",
                        "label-width": "100px"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.form.organization_id,
                            modelValue: _ctx.form.department_id,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.department_id) = $event)),
                            disabled: _ctx.form.add_update === 'update',
                            onDepartmentNameChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.department_name = $event)),
                            placeholder: "部門を選択"
                          }, null, 8, ["organization-id", "modelValue", "disabled"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: "カテゴリ",
                    prop: "category_id",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CategorySelect, {
                        "organization-id": _ctx.form.organization_id,
                        modelValue: _ctx.form.category_id,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.category_id) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onCategoryNameChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.form.category_name = $event)),
                        placeholder: "カテゴリを選択"
                      }, null, 8, ["organization-id", "modelValue", "disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "アイテム名",
                    prop: "material_code",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_MaterialSelect, {
                        "organization-id": _ctx.form.organization_id,
                        "category-id": _ctx.form.category_id,
                        modelValue: _ctx.form.material_code,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.material_code) = $event)),
                        disabled: _ctx.form.add_update === 'update',
                        onMaterialNameChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.material_name = $event)),
                        "onUpdate:organizationId": _ctx.updateOrganizationId,
                        "onUpdate:categoryId": _ctx.updateCategoryId,
                        "onUpdate:expirationDay": _ctx.updateExpirationDate,
                        placeholder: "アイテム名を選択"
                      }, null, 8, ["organization-id", "category-id", "modelValue", "disabled", "onUpdate:organizationId", "onUpdate:categoryId", "onUpdate:expirationDay"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "在庫数",
                    prop: "quantity",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.form.quantity,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.quantity) = $event)),
                        min: 0,
                        max: 999999
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_269, [
                  _createVNode(_component_el_form_item, {
                    label: "保管日",
                    prop: "storage_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.storage_date,
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.storage_date) = $event)),
                        type: "date",
                        placeholder: "保管日を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "有効期限",
                    prop: "expiration_date",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.expiration_date,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.expiration_date) = $event)),
                        type: "date",
                        placeholder: "有効期限を選択"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "保管場所",
                    prop: "location",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.location,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.location) = $event)),
                        autocomplete: "off",
                        placeholder: "保管場所を入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "コメント",
                    prop: "comment",
                    "label-width": "100px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.comment,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.comment) = $event)),
                        autocomplete: "off",
                        placeholder: "コメントを入力"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"]),
          _createElementVNode("div", _hoisted_270, [
            _createVNode(_component_el_upload, {
              action: "#",
              "list-type": "picture-card",
              "auto-upload": false,
              "on-change": _ctx.handleImageChange,
              multiple: "",
              "on-remove": _ctx.handleRemove,
              limit: 3,
              "on-exceed": _ctx.handleExceed,
              "file-list": _ctx.fileList,
              accept: ".jpg,.jpeg,.png,.webp,.gif"
            }, {
              file: _withCtx(({ file }) => [
                _createElementVNode("div", _hoisted_271, [
                  _createElementVNode("img", {
                    class: "el-upload-list__item-thumbnail",
                    src: file.url,
                    alt: ""
                  }, null, 8, _hoisted_272),
                  _createElementVNode("span", _hoisted_273, [
                    _createElementVNode("span", {
                      class: "el-upload-list__item-preview",
                      onClick: ($event: any) => (_ctx.handlePictureCardPreview(file))
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_zoom_in)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_274),
                    (!_ctx.disabled)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "el-upload-list__item-delete",
                          onClick: ($event: any) => (_ctx.handleRemove(file))
                        }, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          })
                        ], 8, _hoisted_275))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["on-change", "on-remove", "on-exceed", "file-list"])
          ])
        ]),
        _createElementVNode("div", _hoisted_276, [
          (_ctx.barcodeScannerState)
            ? (_openBlock(), _createElementBlock("div", _hoisted_277, [
                _createVNode(_component_BarcodeScanner, {
                  ref: "barcodeScannerRef",
                  onCodeScanned: _ctx.handleScanSuccess,
                  onScanStopped: _cache[31] || (_cache[31] = ($event: any) => (_ctx.barcodeScannerState = false))
                }, null, 8, ["onCodeScanned"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_280, [
          _createElementVNode("img", {
            "w-full": "",
            src: _ctx.dialogImageUrl,
            alt: "Preview Image"
          }, null, 8, _hoisted_281)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.dialogAlarmVisible,
      "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.dialogAlarmVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_282, [
          (_ctx.alarmForm.add_update === 'update')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "danger",
                onClick: _ctx.handleDeleteReminderSetting
              }, {
                default: _withCtx(() => _cache[83] || (_cache[83] = [
                  _createTextVNode(" 削除 ")
                ])),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_283, [
            _createVNode(_component_el_button, {
              onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.dialogAlarmVisible = false))
            }, {
              default: _withCtx(() => _cache[84] || (_cache[84] = [
                _createTextVNode("キャンセル")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.handleAlarmSubmit(_ctx.alarmFormRef)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.alarmForm.add_update === 'add' ? '登録' : '更新'), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.alarmForm,
          rules: _ctx.alarmRules,
          ref: "alarmFormRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "責任者" }, {
              default: _withCtx(() => [
                _createVNode(_component_UserSelect, {
                  "organization-id": _ctx.alarmForm.organization_id,
                  modelValue: _ctx.alarmForm.responsible_person,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.alarmForm.responsible_person) = $event)),
                  placeholder: "責任者を選択"
                }, null, 8, ["organization-id", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "アラート設定" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: _ctx.alarmForm.alarm_setting,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.alarmForm.alarm_setting) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_checkbox, { label: "1日以内" }, {
                      default: _withCtx(() => _cache[77] || (_cache[77] = [
                        _createTextVNode("1日以内")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "1日前" }, {
                      default: _withCtx(() => _cache[78] || (_cache[78] = [
                        _createTextVNode("1日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "7日前" }, {
                      default: _withCtx(() => _cache[79] || (_cache[79] = [
                        _createTextVNode("7日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "15日前" }, {
                      default: _withCtx(() => _cache[80] || (_cache[80] = [
                        _createTextVNode("15日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "30日前" }, {
                      default: _withCtx(() => _cache[81] || (_cache[81] = [
                        _createTextVNode("30日前")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_el_checkbox, { label: "在庫数" }, {
                      default: _withCtx(() => _cache[82] || (_cache[82] = [
                        _createTextVNode("在庫数")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.alarmForm.alarm_setting.includes('在庫数'))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "在庫数"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _ctx.alarmForm.quantity,
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.alarmForm.quantity) = $event)),
                      min: 0,
                      max: 999999
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, { label: "有効" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.alarmForm.is_actived,
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.alarmForm.is_actived) = $event)),
                  "active-value": "1",
                  "inactive-value": "0"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_QuantityEditDrawer, {
      modelValue: _ctx.quantityDrawerVisible,
      "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.quantityDrawerVisible) = $event)),
      quantity: _ctx.editingItem?.quantity || 0,
      onConfirm: _ctx.handleQuantityConfirm,
      onCancel: _ctx.handleQuantityCancel
    }, null, 8, ["modelValue", "quantity", "onConfirm", "onCancel"])
  ], 64))
}